
		<base-modal
			[title]="title"
			[isLoading]="isLoading"
			[isBtnOkActive]="isBtnOkActive"
			(onOk)="ok()">
			<form [formGroup]="form">
				<div class="form-group">
					<label for="name">email</label>
					<input type="text" class="form-control" id="email" formControlName="email"
						   [formErrorIndicator]="email"
					/>
				</div>

				<a role="button" class="btn btn-link" (click)="addAllow()">
					<i class="fa fa-fw fa-plus"></i>
				</a>
				
				<div formGroupName="allows">
					<table class="table">
						<thead>
							<tr>
								<th></th>
								<th>provider</th>
								<th>role</th>
							</tr>
						</thead>
						
						<tbody>
							<tr *ngFor="let allow of allows.controls; let i=index">
								<td>
									<div class="form-group"  formGroupName="{{i}}">
										<a role="button" class="btn btn-link" (click)="deleteRole(allow)">
											<i class="fa fa-fw fa-trash"></i>
										</a>
									</div>
								</td>
								
								<td>
									<div class="form-group" formGroupName="{{i}}">
										<select class="form-control" formControlName="providerName">
											<option *ngFor="let p of [''].concat(providerNameList).sort()" value="{{ p }}" [selected]="providerName === p">
												{{ p }}
											</option>
										</select>
									</div>
								</td>
								
								<td>
									<div class="form-group" formGroupName="{{i}}">
										<select class="form-control" formControlName="role">
											<option *ngFor="let r of ['', 'adminPromocodes'].concat(roleNameList).sort()" value="{{ r }}" [selected]="role === r">
												{{ r }}
											</option>
										</select>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</form>
		</base-modal>
	